import * as React from "react"
import PhoneInput from "react-phone-number-input"
import { cn } from "../../lib/utils"

const TransparentInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>((props, ref) => (
    <input
        ref={ref}
        {...props}
        className={cn(
            "border-0 border-none shadow-none outline-none ring-0 focus-visible:ring-0 focus:ring-0 focus:outline-none bg-transparent h-full w-full py-2 px-3 rounded-none placeholder:text-muted-foreground text-sm",
            props.className
        )}
    />
))
TransparentInput.displayName = "TransparentInput"

const PhoneInputComp = React.forwardRef<any, any>(
    ({ className, ...props }, ref) => {
        return (
            <PhoneInput
                ref={ref}
                className={cn("flex", className)}
                inputComponent={TransparentInput}
                onChange={props.onChange}
                limitMaxLength={true}
                international={true}
                countryCallingCodeEditable={false}
                {...props}
            />
        )
    }
)
PhoneInputComp.displayName = "PhoneInput"

export { PhoneInputComp as PhoneInput }
